import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      exact: true
    },
    {
      path: '/words',
      name: 'words',
      label: 'Word Counter',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "words" */ './views/Words.vue'),
    },
    {
      path: '/days',
      name: 'days',
      label: 'Days Calculator',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "days" */ './views/Days.vue'),
    },
    {
      path: '/barcodes',
      name: 'barcodes',
      label: 'Barcodes',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "barcodes" */ './views/Barcodes.vue'),
    },
    {
      path: '/json',
      name: 'json',
      label: 'JSON Tools',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "json" */ './views/JSON.vue'),
    },
    {
      path: '/lists',
      name: 'lists',
      label: 'List Tools',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "json" */ './views/ListProcessor.vue'),
    }
  ]
});
